<template>
   <v-app id="inspire">
      <v-content>
         <v-container fluid fill-height>
            <v-layout align-center justify-center>
               <v-flex xs12 sm8 md4>
                  <v-card class="elevation-12">
                     <v-toolbar dark color="primary">
                        <v-toolbar-title>Amor input text example</v-toolbar-title>
                     </v-toolbar>
                     <v-card-text>
                        <v-form>
                           <v-text-field
                              name="login"
                              label="Escribe una plabra que inspire amor"
                              type="text"
                              v-model="inputText"
                           ></v-text-field>
                        </v-form>
                     </v-card-text>
                     <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary"
                        :disabled="!connected || inputText.length < 4"
                        v-on:click="sendText()">SEND</v-btn>
                        <v-spacer></v-spacer>
                     </v-card-actions>
                  </v-card>
               </v-flex>
            </v-layout>
         </v-container>
      </v-content>
   </v-app>
</template>

<script>
/* eslint-disable */
import HelloWorld from './components/HelloWorld';
import  mqtt from 'mqtt/dist/mqtt';

export default {
  name: 'App',

  components: {    
  },

  mounted(){
    console.log("I'm mounted")
    this.mqttClient = mqtt.connect('wss://mqtt2.iglor.es:10443/mqtt')
    this.mqttClient.on('connect',this.onConnect)
    this.inputText = ''
  },

  data: () => ({
    mqttClient: null,
    connected: false,
    inputText: '',
  }),
  methods:{
    onConnect(){
      console.log("mqtt connected")
      this.connected = true
    },
    sendText(){
      this.mqttClient.publish('touchdesigner',this.inputText)
    }
  }
};
</script>
